import type { AiModelContent } from './aiLeagueTypes';
import { CHATGPT_AI_CONTENT } from './models/chatgpt';
import { CLAUDE_AI_CONTENT } from './models/claude';
import { DEEPSEEK_AI_CONTENT } from './models/deepseek';
import { FABLE5_AI_CONTENT } from './models/fable5';
import { GEMINI_AI_CONTENT } from './models/gemini';
import { GROK_AI_CONTENT } from './models/grok';

export const AI_MODEL_CONTENT: AiModelContent[] = [
  CHATGPT_AI_CONTENT,
  CLAUDE_AI_CONTENT,
  GEMINI_AI_CONTENT,
  GROK_AI_CONTENT,
  DEEPSEEK_AI_CONTENT,
  FABLE5_AI_CONTENT,
];

export const AI_MODEL_CONTENT_BY_ID: Record<AiModelContent['id'], AiModelContent> = {
  chatgpt: CHATGPT_AI_CONTENT,
  claude: CLAUDE_AI_CONTENT,
  gemini: GEMINI_AI_CONTENT,
  grok: GROK_AI_CONTENT,
  deepseek: DEEPSEEK_AI_CONTENT,
  fable5: FABLE5_AI_CONTENT,
};

export const AI_LEAGUE_INTRO_TITLE = 'What is the AI League?';

/** Author intro on the AI League tab (one line per paragraph; last line includes a Methodology link). */
export const AI_LEAGUE_INTRO_LINES = [
  'We asked several AI models to generate a winning 10 Teams list.',
  'We thought it would be interesting to observe what large language models would come up with when prompted identically.',
  'This isn’t a robust experiment (it’s just for fun) but it should demonstrate how these particular frontier AI models handle a football prediction task.',
  'It also serves as a benchmark for users. All 6 models will be in the Global League like other players. Can you beat all 6?',
] as const;

/** Shown on model tabs when a swap is saved but no rationale has been published yet. */
export const AI_LEAGUE_SWAP_JUSTIFICATION_PLACEHOLDER =
  'This model’s explanation for its swap decision will be published here shortly.';
